import { RouterProvider, type RouterProviderProps } from 'react-router';

import type { AuthProviderProps } from './auth/AuthProvider';
import { AppProviders } from './providers/AppProviders';

export interface AppProps extends Omit<AuthProviderProps, 'children'> {
  readonly router: RouterProviderProps['router'];
}

export function App({ router, ...providerProps }: AppProps) {
  return (
    <AppProviders {...providerProps}>
      <RouterProvider router={router} />
    </AppProviders>
  );
}
